import {ApiResponse} from "../models/api-response.model";

export interface NonUserEmployee {
    id: number
    firstName: string
    middleName: string
    lastName: string
    email: string
    phone: string
}


export interface SignupRequest {
    employeeId: string
    password: string
}

export interface SignupResponse {
    employeeId: number
    firstName: string
    middleName: string
    lastName: string
    email: string
    phone: string
    address: string
}

export const loadNonUserEmployees = async (): Promise<ApiResponse<NonUserEmployee[]>> => {
    const response = await fetch('/api/v1/common/guest-user-account/non-user-employees', {
        method: 'GET'
    });
    return await response.json();
};

export const signup = async (request: SignupRequest): Promise<ApiResponse<SignupResponse>> => {
    const response = await fetch('/api/v1/common/guest-user-account/register', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(request)
    });
    return await response.json();
};